module.exports = __webpack_public_path__ + "img/RCV.c345a9fd.jpg";